import React from "react";

function repo(props) {
  const {
    name,
    description,
    language,
    forks,
    watchers_count,
    html_url
  } = props.data;
  return (
    <div className="row ">
      <div className="col s12 ">
        <div className="card hoverable black">
          <div className="card-content white-text">
            <span className="card-title bold poppins capitalize">
              <a
                href={html_url}
                target="_blank"
                className="white-text"
                rel="noopener noreferrer"
              >
                {name}
              </a>
            </span>
            <p>{description}</p>
          </div>
          <div className="card-action">
            {language ? (
              <div className="chip white black-text">{language}</div>
            ) : null}
            <div className="chip white black-text">
              <b>{forks}</b>
              <i className="material-icons">call_split</i>
            </div>
            <div className="chip white black-text">
              <b>{watchers_count}</b>
              <i className="material-icons">remove_red_eye</i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default repo;
